let kefucommons={
	callkefu_YP:function(){
	    this.callkefu('7797cf0df6a54dcba304e6381206eb67');
	  },
	  callkefu_XH:function(){
	    this.callkefu('d9cb846c4e5e46e5b5643e90d7ec9063');
	  },
	  callkefu_SJ:function(){
	    this.callkefu('226aadeae7ec4a86913a216ad10b2a82');
	  },
	  callkefu_JD:function(){
	    this.callkefu('8dcb372f2e7b4ebabc8cfe0d07865f1b');
	  },
	  callkefu_QP:function(){
	    this.callkefu('b142bb300ff7487fbaac0a13020b8cd0');
	  },
	  callkefu_CM:function(){
	    this.callkefu('bd60e006317b4d589ba88244de318028');
	  },
	  callkefu_PD:function(){
	    this.callkefu('f7cf797ae4e84599a42e5f34e2dcacf8');
	  },
	g_framestatus:false,
	init:function(){
		(function (w, d, e, x) {
		      w[e] = function () {
		        w.cbk = w.cbk || []
		        w.cbk.push(arguments);
		      }
		      x = d.createElement('script');
		      x.async = true;
		      x.id = 'zhichiScript';
		      x.className = 'zcBtn',  //该class可自行设置，只需要在使用的自定义入口上同名即可
		        x.src = 'https://huazhi.soboten.com/chat/frame/v6/entrance.js?sysnum=dd1459f299da466381e0e1e23f874fca';
		      d.body.appendChild(x);
		    })(window, document, 'zc');
		
		    zc('config', {
		      //设置自定义按钮生效
		      custom: true,
		      // groupid:'0e5ded649caf4ddf91f18cb9edf40ca3',
		      refresh:true,
		      man_trace:true,
		    });
	},
	framefresh(){
	        if(kefucommons.g_framestatus){
	         zc('frame_status');
	         kefucommons.g_framestatus=true;
	        }
	        else{
	            zc('frame_status');
	            zc('frame_status');
	        }
	},
	callkefu:function(kefucode){
		if(!kefucode){
		  kefucode = "0e5ded649caf4ddf91f18cb9edf40ca3";
		} 
		// zc("config",{
		// 		   groupid:kefucode, //配置技能组 当客户咨询人工客服时，会先选择需要咨询的业务
		//    })
		
		var action = [
			    {
			      "actionType":"to_group",
			      "optionId":"3",
			      "deciId":kefucode,
			      "spillId":"4"
			    },
			   {
			      "actionType":"to_group",
			      "optionId":"4",
			      "deciId":"0e5ded649caf4ddf91f18cb9edf40ca3"
			    }
		];
		var payload = JSON.stringify(action);
		zc('config', {
		  transfer_action:payload,
		});
		kefucommons.framefresh();
		
		 
	}
}

export { kefucommons }